import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import { Checkbox } from 'antd';
import TrustHandbookAPI from '../../../api/trustHandbook';
import Button from '../../../components/global/Button';

import './TrustHandbook.scss';

pdfjs.GlobalWorkerOptions.workerSrc = window.location.origin + '/pdf.worker.min.mjs';

const TrustHandBook = (props) => {
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [handbookConfirmation, setHandbookConfirmation] = useState(false);
  const [handbookUrl, setHandbookUrl] = useState(null);

  const queryParams = new URLSearchParams(props.location.search);
  const username = queryParams.get('username');

  useEffect(() => {
    try {
      TrustHandbookAPI.getTrustHandbook(props.preferredLanguage, username)
        .then((result) => {
          setHandbookUrl(result.data);
        })
        .catch((error) => {
          console.warn('error:', error);
        });
    } catch (err) {
      console.warn('err:', err);
    }
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  function nextPage() {
    setPageNumber((v) => ++v);
  }

  function prevPage() {
    setPageNumber((v) => --v);
  }

  const onSubmit = () => {
    props.onAcceptTrustHandbook();
  };

  const options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
  };

  return (
    <div style={{ width: '100%', height: '100%' }}>
      <p>
        Ask Aunty helps International healthcare professionals settle into the UK and adapt to the NHS. 
        Please confirm receipt of your Trust's handbook, which you can read later at any time.
      </p>
      {handbookUrl ? (
        <>
          <div className="pdf-container">
            <Document
              file={handbookUrl}
              onLoadSuccess={onDocumentLoadSuccess}
              className="my-react-pdf"
              options={options}
            >
              <Page pageNumber={pageNumber} />
            </Document>
          </div>

          <p className="page-number">
            Page {pageNumber} of {numPages}
          </p>
          <div className="d-flex pb-3 justify-content-center">
            <div className="d-flex">
              <Button.Primary
                style={{ width: '100px' }}
                buttonSize={'small'}
                onClick={prevPage}
                disabled={pageNumber <= 1}
              >
                Previous
              </Button.Primary>

              <div className="pr-2" />

              <Button.Primary
                buttonSize={'small'}
                onClick={nextPage}
                style={{ width: '100px' }}
                disabled={pageNumber >= (numPages ?? -1)}
              >
                Next
              </Button.Primary>
            </div>
          </div>

          <div className="w-100 d-flex align-items-center justify-content-center">
            <div
              className="d-flex align-items-center justify-content-start agreements-checkbox-container pl-0"
              style={{ position: 'relative' }}
            >
              <Checkbox
                style={{ position: 'relative' }}
                className="onboarding-agreements-checkbox"
                checked={handbookConfirmation}
                onChange={() => setHandbookConfirmation(!handbookConfirmation)}
              >
                <span style={{ color: 'rgba(0,0,0,.65)' }}>
                  I confirm receipt of the Trust's handbook *
                </span>
              </Checkbox>
            </div>
          </div>
        </>
      ) : null}

      <Button.Primary onClick={onSubmit} disabled={!handbookConfirmation && handbookUrl}>
        Enter Ask Aunty App
      </Button.Primary>
    </div>
  );
};

export default TrustHandBook;
